/* global Stripe */
"use strict";

($dt => {

	/**
	 * Loads the Stripe JS
	 * 
	 * @return { void }
	 */
	function load_stripe_js() {
		const js_elem = document.createElement('script');
		js_elem.src = 'https://js.stripe.com/v3/';
		js_elem.type = 'text/javascript';
		js_elem.setAttribute('async', '');
		document.body.append(js_elem);
	}

	/**
	 * Attempts to safely load the Stripe library by checking to see if its already available.
	 * 
	 * @param { () => {} } on_loaded
	 * 
	 * @return { void }
	 */
	function safely_load_stripe(on_loaded){
		$dt.OnLibraryAvailable([ 'Stripe' ], on_loaded, 1, 5, () => {
			load_stripe_js();
			on_loaded();
		});
	}

	const controller = {
		enabled: true,
		stripe: null,
		elements: null,

		initApi: location_key => {
			controller.stripe = new Stripe($dt.stripe[location_key]);
			return controller.stripe;
		},

		/**
		 * https://docs.stripe.com/js/elements_object/create
		 * @param { string } location_key 
		 * @param { string } cs 
		 * @returns { * }
		 */
		createPaymentElement: () => {
			const options = {
				layout: 'tabs',
				fields: {
					billingDetails: {
						name: 'auto',
						email: 'auto',
						phone: 'never',
						address: 'never'
					}
				}
			};
			return controller.elements.create('payment', options);
		},

		/**
		 * https://docs.stripe.com/js/elements_object/create
		 * @param { string } location_key 
		 * @param { string } cs 
		 * @returns { * }
		 */
		createAddressElement: (contact_info) => {
			const options = {
				mode: 'billing',
				defaultValues: {
					address: {
						state: 'CA',
						country: 'US'
					}
				}
			};
			if (contact_info) {
				options.defaultValues = {
					name: contact_info.firstname + ' ' + contact_info.lastname,
					address: {
						line1: contact_info.street_address1,
						city: contact_info.city,
						state: contact_info.state,
						postal_code: contact_info.zip,
						country: 'US'
					}
				};
			}
			return controller.elements.create('address', options);
		},

		/**
		 * https://docs.stripe.com/js/elements_object/create
		 * @param { string } location_key 
		 * @param { string } cs
		 */
		createNewElements: (location_key, cs) => {
			const stripe = controller.initApi(location_key);
			controller.elements = stripe.elements({
				clientSecret: cs,
				appearance: {}
			});
		},

		/**
		 * @param { string|null } return_url 
		 * @param { bool|null } only_redirect_if_required 
		 * @returns 
		 */
		confirmPayment: (return_url, only_redirect_if_required) => {
			const options = { elements: controller.elements };
			if (return_url) {
				options.confirmParams = { return_url: return_url };
			}
			if (only_redirect_if_required) {
				options.redirect = 'if_required';
			}
			return controller.stripe.confirmPayment(options);
		}
	};

	// Set controller unavailable
	$dt.Stripe = { enabled: false };

	// Auto start functionality
	$dt.autostart.push(() => {
		if ($dt.stripe && $dt.stripe['orange-county'] !== null && $dt.stripe['los-angeles'] !== null) {
			if ($dt.stripe.quickload) {
				load_stripe_js();
				$dt.Stripe = controller;
			} else {
				safely_load_stripe(() => {
					$dt.Stripe = controller;
				});
			}
		}
	});
	
})(window.d3_wp_themejs);
